var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('survey-screen',{attrs:{"questions":_vm.questions,"brands":_vm.brands,"defaultUserAnswer":_vm.defaultUserAnswer}})}
var staticRenderFns = []

export { render, staticRenderFns }